import React from "react";
import { Box,  useMediaQuery } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Skeleton from "@mui/material/Skeleton";
import { StyledTab } from "./mealTabs";
import "../utils/myMealsCSS.css";

export default function MealTabsSkeleton() {
  const isTabletOrMobile = useMediaQuery("(max-width:824px)", { noSsr: true });

  return (
    <Box
      sx={{
        position: "sticky",
        bottom: 0,
        right: 0,
        left: 0,
        overflow: "hidden",
        backgroundColor: "#fff",
        height: !isTabletOrMobile && "80vh",
        display: "flex",
        alignItems: "flex-start",
        flexDirection: "column",
      }}
      id="MealTabsSkeleton"
    >
      <Tabs
        allowScrollButtonsMobile
        scrollButtons={false}
        indicatorColor="none"
        orientation={isTabletOrMobile ? "horizontal" : "vertical"}
        selectionFollowsFocus={true}
        sx={{ height: "100%", width: "100%" }}
        textColor="primary"
        value={1}
        variant="scrollable"
      >
        <Skeleton
          component={StyledTab}
          value={1}
          style={{ margin: "5px" }}
          variant="rectangular"
          width={"210px"}
          height={"60px"}
        />
        <Skeleton
          component={StyledTab}
          value={2}
          style={{ margin: "5px" }}
          variant="rectangular"
          width={"210px"}
          height={"60px"}
        />
        <Skeleton
          component={StyledTab}
          value={3}
          style={{ margin: "5px" }}
          variant="rectangular"
          width={"210px"}
          height={"60px"}
        />
        <Skeleton
          component={StyledTab}
          value={4}
          style={{ margin: "5px" }}
          variant="rectangular"
          width={"210px"}
          height={"60px"}
        />
        <Skeleton
          component={StyledTab}
          value={5}
          style={{ margin: "5px" }}
          variant="rectangular"
          width={"210px"}
          height={"60px"}
        />
      </Tabs>
    </Box>
  );
}
